<template>
  <div>
    <div style="w-100">
      <div class="d-flex" style="position: absolute; z-index: 2 !important">
        <Button
          :size="15"
          color="#fd7e14"
          colorText="#ffffff"
          tooltip="Filtrar contenido"
          icon="fas fa-filter"
          round
          :width="30"
          class="mt-2 mb-3 mr-2"
          @click.native="openModal('modal')"
          traslate
        />
        <Button
          :size="15"
          color="#dc3545"
          colorText="#ffffff"
          tooltip="Borrar contenido Filtrado"
          icon="fas fa-filter"
          round
          :width="30"
          class="mt-2 mb-3 mr-2"
          traslate
          @click.native="clear()"
        />
      </div>
    </div>

    <ui-modal ref="modal" title="Filtros" size="auto">
      <div class="d-flex">
        <!-- ID -->
        <ui-textbox
          class="w-50 mr-2"
          label="ID"
          placeholder="Ingrese ID Booking"
          v-model="idBookingModel"
        />

        <!-- Número de booking -->
        <ui-textbox
          class="w-50 ml-1 mr-1"
          label="Número de booking"
          placeholder="Ingrese Numero de Booking"
          v-model="numeroBookingModel"
        />
        <!-- Cliente -->
        <ui-select
          class="w-50 ml-1 mr-1"
          has-search
          label="Cliente"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          v-model="clienteModel"
          :options="dataListaClienteLA"
          :keys="{ label: 'name', value: 'id' }"
        />
      </div>

      <div class="d-flex pt-2">
        <!-- Nave -->
        <ui-textbox
          class="w-50 ml-1 mr-1"
          label="Nave"
          placeholder="Ingrese Nave"
          v-model="naveModel"
        />
        <!-- Naviera -->
        <ui-select
          class="w-50 mr-2"
          has-search
          label="Naviera"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          v-model="navieraModel"
          :keys="{ label: 'name', value: 'id' }"
          :options="navieras"
        />

        <!-- Puerto -->
        <ui-select
          class="w-50 ml-2"
          has-search
          label="Puerto"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          v-model="podModel"
          :keys="{ label: 'name', value: 'id' }"
          :options="dataListaPodLA"
        />
      </div>

      <div class="d-flex pt-2">
        <!-- Año -->
        <ui-select
          class="w-50 mr-2"
          has-search
          label="Año"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          v-model="anioModel"
          :keys="{ label: 'name', value: 'id' }"
          :options="dataListaAnioLA"
        />
        <!-- Semana -->
        <ui-select
          class="w-50 ml-1 mr-1"
          has-search
          label="Semana"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          v-model="semanaModel"
          :keys="{ label: 'name', value: 'id' }"
          :options="dataListaSemanaLA"
        />
        <!-- Comercial -->
        <ui-select
          class="w-50 ml-2"
          has-search
          label="Comercial"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          v-model="comercialModel"
          :keys="{ label: 'name', value: 'id' }"
          :options="dataListaComercialLA"
        />
      </div>

      <!-- Footer -->
      <div class="d-flex justify-content-between mt-5">
        <button class="btn btn-default" @click="closeModal('modal')">
          Cerrar
        </button>
        <div style="float: right">
          <button
            class="btn btn-secondary"
            style="margin-right: 25px"
            @click="clear"
          >
            Limpiar
          </button>
          <button class="btn btn-danger" @click="filtrarLista" :disabled="!filter_btn_active">
            {{ filter_btn_text }}
          </button>
        </div>
      </div>
    </ui-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
// Select UI
import UiSelect from "keen-ui/src/UiSelect";
import UiModal from "keen-ui/src/UiModal";
import UiTextbox from "keen-ui/src/UiTextbox";
// Common
import Button from "../../../common/Button";
import { getBookingsLateArrivalsFiltrados } from "@/constants/lineas";

export default {
  data() {
    return {
      idBookingModel: "",
      clienteModel: "",
      naveModel: "",
      navieraModel: "",
      numeroBookingModel: "",
      podModel: "",
      anioModel: "",
      semanaModel: "",
      comercialModel: "",
      filter_btn_text: "Filtrar",
      filter_btn_active: true,
      dataFilter: this.dataDatatableBookingsLateArrivalsFiltrada,
    };
  },
  computed: {
    ...mapState("lineas", [
      "dataDatatableBookingsLateArrivalsFiltrada",
      "dataListaPodLA",
      "dataListaSemanaLA",
      "dataListaClienteLA",
      "dataListaComercialLA",
      "dataListaAnioLA"
    ]),
    ...mapState(["navieras"])
  },
  components: {
    UiSelect,
    UiModal,
    Button,
    UiTextbox
  },
  methods: {
    ...mapActions("lineas", [
      "actionSetDataBookingsLateArrivals",
      "actionFilterDataBookingsLateArrivals",
      "actionLimpiarDataBookingsLateArrivals",
    ]),
    clear() {
      this.idBookingModel = "";
      this.clienteModel = "";
      this.naveModel = "";
      this.navieraModel = "";
      this.numeroBookingModel = "";
      this.podModel = "";
      this.anioModel = "";
      this.semanaModel = "";
      this.comercialModel = "";
      this.actionLimpiarDataBookingsLateArrivals();
      this.loadingButton(true);
    },
    async filtrarLista() {

      this.loadingButton(false);

      this.actionLimpiarDataBookingsLateArrivals();

      let filters = {
        id: this.idBookingModel ?? null,
        cliente: this.clienteModel.id ?? null,
        nave: this.naveModel ?? null,
        naviera: this.navieraModel.id ?? null,
        no_booking: this.numeroBookingModel ?? null,
        pod: this.podModel.id ?? null,
        anio: this.anioModel ?? null,
        semana: this.semanaModel.id ?? null,
        comercial: this.comercialModel.id ?? null

      };

      let dataFiltrada = await getBookingsLateArrivalsFiltrados(filters);

      this.actionFilterDataBookingsLateArrivals(dataFiltrada);

      this.loadingButton(true);

      this.closeModal("modal");
    },
    loadingButton(active){
      if (!active) {
        this.filter_btn_text = "Filtrando...";
        this.filter_btn_active = active;
      } else {
        this.filter_btn_text = "Filtrar";
        this.filter_btn_active = active;
      }
    },
    openModal(ref) {
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    }
  }
};
</script>

<style>
.ui-modal--size-large > .ui-modal__wrapper > .ui-modal__container {
    width: 25rem;
}
</style>
